<template>
    <div>
        <h1 class="overskrift">Medlemsregister</h1>
        <b-button
            label="Legg til nytt medlem" 
            type="is-link"
            size="is-small"
            style="margin-bottom:1em;"
            @click="ny()"
        />
        <ApolloQuery 
            :pollInterval="5000"
            :query="require('../graphql/medlemsregister.gql')"
            >
            <template slot-scope="{ result: { data } } ">                    
                <div v-if="data">                                                
                    <table class="table is-bordered is-hoverable">
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>Fornavn</th>
                                <th>Etternavn</th>
                                <th>Fødselsår</th>
                                <th>J/S</th>
                                <th>E-post</th>
                                <th>Registrert</th>
                                <th>Sist betalt</th>
                                <th>Rediger</th>
                            </tr>
                        </thead>
                        <tbody> 
                            <tr v-for="post in data.medlemsregisters" :key="post.id">                           
                                <td>{{toppnummer(post.spillerNummer)}}</td>
                                <td>{{post.fornavn}}</td>
                                <td>{{post.etternavn}}</td>
                                <td align="center">{{post.fodselsar}}</td>
                                <td align="center">{{alder(post.fodselsar)}}</td>
                                <td>{{post.ePost}}</td>
                                <td>{{ moment(post.createdAt).format('ll') }}</td>
                                <td> <span :style="red(post.sistBetalt)"> {{moment(post.sistBetalt).format('ll')}}</span></td>
                                <td>
                                    <button 
                                        class="button is-small is-warning" 
                                        @click="edit( post.id )"
                                    > Rediger </button>
                                </td> 
                            </tr>                          
                        </tbody>
                    </table>                    
                </div>
            </template>
        </ApolloQuery>
        <b-button
            label="Legg til nytt medlem" 
            type="is-link"
            size="is-small"
            style="margin-top:1em;"
            @click="ny()"
        />

        <!-- EDIT-modal -->
        <div class="modal" v-show="showEdit" @close="showEdit = false" :class="{'is-active' : showEdit}">
            <div class="modal-background"></div>
            <div class="modal-card">
                <header class="modal-card-head">
                    <p class="modal-card-title">Nytt medlemsskap</p>
                    <button class="delete" aria-label="close" @click="showEdit = false"></button>
                </header>
                <section class="modal-card-body">
                    <ApolloQuery                                         
                        :query="require('../graphql/enkeltmedlem.gql')"
                        :variables="{ id, fornavn }"
                        >
                        <template slot-scope="{ result: { loading, error, data } } ">  
                            <div v-if="loading">
                                <p>Laster ...</p>
                            </div>                            
                            <div v-else-if="error">
                                <p>Det har oppstått en feil. </p>
                            </div>
                            <div v-else-if="data">
                                <!-- Innhold i søket -->
           
                                <div class="field">
                                    <label class="label">Fornavn</label>
                                    <div class="control">
                                        <input class="input" type="text" v-model="data.medlemsregister.fornavn" />
                                    </div>
                                </div>
                                <div class="field">
                                    <label class="label">Etternavn</label>
                                    <div class="control">
                                        <input class="input" type="text" v-model="data.medlemsregister.etternavn" />
                                    </div>
                                </div>   
                                <div class="field">
                                    <label class="label">Fødselsår</label>
                                    <div class="control">
                                        <input class="input" type="text" v-model="data.medlemsregister.fodselsar" />
                                    </div>
                                </div>  
                                <div class="field">   
                                    <label class="label">E-post</label>
                                    <div class="control">
                                        <input class="input" name="epost" v-model="data.medlemsregister.ePost" />
                                    </div>
                                </div>    
                                <div class="buttons" style="margin-top:2em;">
                                    <b-button
                                        label="Betalt i dag"
                                        type="is-warning"
                                        size="is-medium"
                                        @click="betal(data.medlemsregister.id)"
                                         />   
                                    <b-button
                                        label="Lagre endringer" 
                                        type="is-success"
                                        size="is-medium"
                                        @click="lagre(data.medlemsregister.id, data.medlemsregister.fornavn, data.medlemsregister.etternavn, data.medlemsregister.fodselsar, data.medlemsregister.ePost)"
                                        />
                                    <b-button 
                                        label="Avbryt" 
                                        size="is-medium"
                                        @click="showEdit = false"
                                        />
                                </div>     
                            </div>
                        </template>
                    </ApolloQuery>
                </section>
            </div>
        </div>    

        <!-- NY-modal -->    
        <div class="modal" v-show="showNy" @close="showNy = false" :class="{'is-active' : showNy}">
            <div class="modal-background"></div>
            <div class="modal-card">
                <header class="modal-card-head">
                    <p class="modal-card-title">Rediger medlemsskap</p>
                    <button class="delete" aria-label="close" @click="showNy = false"></button>
                </header>
                <section class="modal-card-body">         
                    <div class="field">
                        <label class="label">Fornavn</label>
                        <div class="control">
                            <input class="input" type="text" v-model="fornavn" />
                        </div>
                    </div>
                    <div class="field">
                        <label class="label">Etternavn</label>
                        <div class="control">
                            <input class="input" type="text" v-model="etternavn"  />
                        </div>
                    </div>   
                    <div class="field">
                        <label class="label">Fødselsår</label>
                        <div class="control">
                            <input class="input" type="text" v-model="fodselsar" />
                        </div>
                    </div>  
                    <div class="field">   
                        <label class="label">E-post</label>
                        <div class="control">
                            <input class="input" name="epost" v-model="epost" />
                        </div>
                    </div>    
                    <div class="buttons" style="margin-top:2em;">
                        <b-button
                            label="Lagre ny" 
                            type="is-success"
                            size="is-medium"
                            @click="lagreNy()"
                            />
                        <b-button 
                            label="Avbryt" 
                            size="is-medium"
                            @click="showNy = false"
                            />
                    </div>     
                </section>
            </div>
        </div>    


    </div>
</template>

<script>
import moment from 'moment'

    export default {
        name: "Medlemmer",
        data() {
            return {
                showEdit: false,
                showNy: false,
                id: "",
                fornavn: "",
                etternavn: "",
                fodselsaar: "",
                epost: "",
                toppNummer: ""
            }
        },  
        methods: {
            red(value) {
                var idag = moment()
                var sistBetalte =  moment(value, 'YYYY-MM-DD').toDate();
                var ifjor = moment(idag).subtract(1, 'years').toDate();
                if(moment(sistBetalte).isBefore(moment(ifjor))) {
                    return 'color:red;'
                } else { return 'color:green;'}             
            },
            alder(value) {
                let iaar = parseInt(new Date().getFullYear());
                let born = parseInt(value)
                let senior = iaar - 18
                if (born < senior) {
                    return "Senior"
                } else { 
                    return "Junior"
                }
            },
            edit(value) {                
                this.id = value; 
                this.showEdit = true;
            },
            betal(value) {
                this.$buefy.dialog.alert('Medlemsskap utvidet med ett år!')
                this.showEdit = false;
                var idag = new Date();
                // Mutation som oppdaterer databasen
                this.$apollo.mutate({
                    mutation: require("../graphql/betaling.gql"),
                    variables: {
                    sistBetalt: idag,
                    id: value
                    },
                })           
            },
            lagre(id, fornavn, etternavn, fodselsar, epost) {
                this.$buefy.dialog.alert('Endringen er lagret')
                this.showEdit = false;
                let fodt = parseInt(fodselsar)
                // Mutiation som oppdaterer databasen
                this.$apollo.mutate({
                    mutation: require("../graphql/endring.gql"),
                    variables: {
                        fornavn: fornavn,
                        etternavn: etternavn,
                        fodselsar: fodt,
                        ePost: epost,
                        id: id
                    }
                })
            },
            lagreNy() {
                let fodt = parseInt(this.fodselsar);
                var idag = new Date();
                // Mutation som legger inn ny
                this.$apollo.mutate({
                    mutation: require("../graphql/nyttmedlem.gql"),
                    variables: {
                        fornavn: this.fornavn,
                        etternavn: this.etternavn,
                        fodselsar: fodt, 
                        ePost: this.epost,
                        sistBetalt: idag,
                        spillerNummer: parseInt(this.toppNummer+1)
                    }
                })                    
                this.$buefy.dialog.alert('Ny spiller lagt inn.<br/>Listen oppdateres om noen sekunder.')
                this.toppNummer = this.toppNummer +1;
                this.showNy = false;                                           
            },
            ny() {
                this.showNy = true;
            },
            toppnummer(value){
                this.toppNummer = value;
                return value;
            }
        }
    }
</script>